import React from 'react'
import constant from '../../../constant'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

const Sidebar = () => {
  return (
    <div className="app-menu navbar-menu">
      <div className="navbar-brand-box">
        <Link to={constant.comapnyAdminComponent.dashBoard.url} className="logo logo-dark">
          <span className="logo-sm">
            <img src="/images/logo/recruit-logo.png" alt="" height={47} />
          </span>
          <span className="logo-lg">
            <img src="/images/logo/recruit-logo.png" alt="" height={47} />
          </span>
        </Link>
        {/* Light Logo*/}
        <a href={constant.comapnyAdminComponent.dashBoard.url} className="logo logo-light">
          <span cflassName="logo-sm">
            <img src="/images/logo/recruit-logo.png" alt="" height={47} />
          </span>
          <span className="logo-lg">
            <img src="/assets/images/logo-light.png" alt="" height={47} />
          </span>
        </a>
        <button
          type="button"
          className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
          id="vertical-hover"
        >
          <i className="ri-record-circle-line" />
        </button>
      </div>
      <div id="scrollbar">
        <div className="container-fluid">
          <div id="two-column-menu"></div>
          <ul className="navbar-nav" id="navbar-nav">
            <li className="menu-title">
              <hr />

            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="javascript:void(0)"
              >
                <i className="ri-dashboard-2-line" />
                <span data-key="t-dashboards">Dashboards</span>
              </a>

            </li>
            <li className="nav-item">
              <a
                className="nav-link menu-link"
                href="#sidebarApps"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="sidebarApps"
              >
                <i className="bx bx-user-circle" /> <span data-key="t-user-managemt">User Management</span>
              </a>
              <div className="collapse menu-dropdown" id="sidebarApps">
                <ul className="nav nav-sm flex-column">
                  <li className="nav-item">
                    <a
                      href={constant.comapnyAdminComponent.addUser.url}
                      className="nav-link"
                      data-key="t-starter"
                    >
                      {" "}
                      Add User{" "}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      href={constant.comapnyAdminComponent.viewUsers.url}
                      className="nav-link"
                      data-key="t-starter"
                    >
                      {" "}
                      View Users{" "}
                    </a>
                  </li>

                </ul>
              </div>
            </li>


            <li className="nav-item">
              <a
                className="nav-link menu-link"
                href="#sidebarMultilevel"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="sidebarMultilevel"
              >
                <i className="bx bx-sitemap" />
                <span data-key="t-multi-level">Client Management</span>
              </a>
              <div className="collapse menu-dropdown" id="sidebarMultilevel">
                <ul className="nav nav-sm flex-column">
                  <li className="nav-item">
                    <Link to={constant.comapnyAdminComponent.addClient.url} className="nav-link" data-key="t-level-1.1">

                      Add Client
                    </Link>
                  </li>
                  <li className="nav-item">
                    <a
                      href={constant.comapnyAdminComponent.viewClients.url}
                      className="nav-link"
                    >
                      Search Client
                    </a>

                  </li>
                </ul>
              </div>
            </li>

            <li className="nav-item">
              <a
                className="nav-link menu-link"
                href="#sidebarPages"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="sidebarPages"
              >
                <i className="ri-settings-2-line" />
                <span data-key="t-pages">Settings</span>
              </a>
              <div className="collapse menu-dropdown" id="sidebarPages">
                <ul className="nav nav-sm flex-column">
                  <li className="nav-item">
                    <Link
                      to={constant.comapnyAdminComponent.designations.url}
                      className="nav-link"
                    >
                      Designations
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to={constant.comapnyAdminComponent.role.url}
                      className="nav-link"
                    >
                      Roles
                    </Link>

                  </li>
                  <li className="nav-item">
                    <Link
                      to={constant.comapnyAdminComponent.workLocation.url}
                      className="nav-link"

                    >
                      Work Locations
                    </Link>

                  </li>
                  <li className="nav-item">
                    <Link
                      to={constant.comapnyAdminComponent.documentType.url}
                      className="nav-link"

                    >
                      Document Type
                    </Link>

                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        {/* Sidebar */}
      </div>

      <div className="sidebar-background" />
    </div>


  )
}

export default Sidebar